<template>
  <div class="content-container">
    <!-- 搜索框 -->
    <a-form-model
      ref="searchForm"
      class="search-form"
      layout="horizontal"
      :model="searchForm"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-row>
        <a-col :span="8">
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.materialName.label')"
          >
            <a-input
              v-model="searchForm.name"
              :placeholder="$t('form.common.field.materialName.placeholder')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.type.label')"
          >
            <a-select
              :placeholder="$t('form.common.field.type.placeholder')"
              v-model="searchForm.type"
              :allowClear="true"
            >
              <a-select-option value="0">{{
                $t("enum.materialType.0")
              }}</a-select-option>
              <a-select-option value="4">{{
                $t("enum.materialType.4")
              }}</a-select-option>
              <a-select-option value="5">{{
                $t("enum.materialType.5")
              }}</a-select-option>
              <a-select-option value="1">{{
                $t("enum.materialType.1")
              }}</a-select-option>
              <a-select-option value="2">{{
                $t("enum.materialType.2")
              }}</a-select-option>
              <a-select-option value="3">{{
                $t("enum.materialType.3")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item>
            <a-button type="primary" html-type="submit" @click="search">{{
              $t(`actionTitles.submit`)
            }}</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
              $t(`actionTitles.clear`)
            }}</a-button>
            <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{expand ? $t('message.collapseClose'):$t('message.collapseOpen')}}
              <a-icon :type="expand? 'up' : 'down'" />
            </a> -->
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  <!-- 提示 -->
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <span>{{ $t("message.workRecycleNotice") }}</span>
        <div style="float: right">
          <a-button type="primary" @click="multipOperate('regain')">{{
            $t(`actionTitles.resume`)
          }}</a-button>
          <a-button
            style="color: red; margin-left: 10px"
            @click="multipOperate('delete')"
            >{{ $t(`actionTitles.delete`) }}</a-button
          >
        </div>
      </div>
      <!-- 已選擇 -->
      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />
<!-- 列表 -->
      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="pageResult.records"
        :loading="loading"
        :rowKey="rowKey"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column
          key="name"
          :title="$t('table.common.thead.name')"
          data-index="name"
        >
          <template slot-scope="text, record">
            <a-row v-if="record.belong === 'pano'" type="flex" align="middle">
              <img :src="record.thumb_path" alt style="width: 40px" />
              <div style="margin-left: 32px">
                <span style="font-weight: bold">{{ record.filename }}</span>
                <!-- <br />
                <span style="font-size:10px">{{record.regoin_name}}</span>-->
              </div>
            </a-row>
            <a-row v-else type="flex" align="middle">
              <div class="work-detail-img" style="margin-right: 40px">
                <img
                  :src="record.url"
                  alt
                  style="width: 40px; height: 40px"
                  v-if="record.type === 1"
                />
                <a-icon
                  type="audio"
                  theme="filled"
                  style="color: #1790ff; font-size: 40px"
                  v-else-if="record.type === 2"
                />
                <a-icon
                  type="video-camera"
                  theme="filled"
                  style="color: #1790ff; font-size: 40px"
                  v-else-if="record.type === 3"
                />
                <img
                  :src="record.cover"
                  alt
                  style="width: 40px; height: 40px; cursor: pointer"
                  @click="perview(record)"
                  v-else-if="record.cover && record.type === 4"
                />
                <img
                  :src="record.cover"
                  alt
                  style="width: 40px; height: 40px; cursor: pointer"
                  @click="perview(record)"
                  v-else-if="record.cover && record.type === 5"
                />
                <a-icon
                  type="folder"
                  theme="filled"
                  v-else
                  style="color: #1790ff; font-size: 40px"
                />
              </div>
              <span>{{ record.name ? record.name : record.filename }}</span>
            </a-row>
          </template>
        </a-table-column>
        <!-- <a-table-column
          key="readCount"
          :title="$t('table.work.thead.readCount')"
          data-index="total_browse"
        />-->
        <!-- <a-table-column key="state" :title="$t('table.common.thead.state')" data-index="is_public">
          <template slot-scope="text, record">{{$t(`enum.workIsPublic.${record.is_public}`)}}</template>
        </a-table-column>-->
        <a-table-column
          key="updateTime"
          :title="$t('table.common.thead.updateTime')"
          data-index="create_time"
        />
        <a-table-column key="operate" :title="$t('table.common.thead.operate')">
          <template slot-scope="text, record">
            <span>
              <a @click="regain(record)">{{ $t("actionTitles.resume") }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.deleteHint')"
                @confirm="() => materialDelete(record)"
              >
                <a style="color: red">{{ $t("actionTitles.delete") }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { recycle, materialDelete, regain } from "@/api/planeMaterial";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      workList: [],
      searchForm: {
        name: "",
        type: undefined,
      },
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  components: { ClearSelected },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.loadData();
    console.log("00000",this.searchForm)
  },
  updated() {},
  methods: {
    loadData() {
      this.loading = true;
      // this.searchParam = {
      //   ...{
      //     current_page: this.pagination.current,
      //     per_page: this.pagination.pageSize,
      //   },
      // };
         let searchParam = {...this.searchForm,...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        }}
      recycle(searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
          this.selectedRowKeys = [];
          this.selectedRows = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.pagination.current=1;
      this.searchForm = { type: undefined };
      this.loadData();
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    },
    rowKey(record) {
      return record.id;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.loadData();
    },
    regain(record) {
      let idList = [];
      if (record.belong === "pano") {
        idList.push({ id: record.id, type: "pano" });
      } else {
        idList.push({ id: record.id, type: "material" });
      }
      this.onRegain(idList);
    },
    onRegain(idList) {
      regain(idList)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.regainSuccess"), 2, () => {
              this.loadData();
              if (this.selectedRowKeys.length) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
            });
          }
        })
        .catch(() => {});
    },
    materialDelete(record) {
      let idList = [];
      if (record.belong === "pano") {
        idList.push({ id: record.id, type: "pano" });
      } else {
        idList.push({ id: record.id, type: "material" });
      }
      this.onDelete(idList);
    },
    onDelete(idList) {
      materialDelete(idList)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
              if (this.selectedRowKeys.length) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
            });
          }
        })
        .catch(() => {});
    },
    multipOperate(type) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning(this.$t("message.selectHint"), 2);
      } else {
        let idList = this.selectedRows.map((v) => {
          let info = { id: v.id };
          if (v.belong === "pano") {
            info.type = "pano";
          } else {
            info.type = "material";
          }
          return info;
        });
        if (type === "regain") {
          this.onRegain(idList);
        } else if (type === "delete") {
          this.onDelete(idList);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.specialBtn {
  background-color: #7101ad;
  border-color:#7101ad
}
</style>
